<template>
  <b-modal
    id="send-sms-modal"
    title="Lähtä SMS"
    ok-title="Lähetä"
    cancel-title="Peru"
    :ok-disabled="!body"
    @ok="sendSMS"
  >
    <b-form>
      <b-form-textarea v-model="body" placeholder="Input message" />
      <p class="mt-1 d-flex justify-content-between">
        <span> Segments: {{ Math.ceil(body.length / LENGTH_PER_SMS) }} </span>
        <span> {{ body ? body.length % LENGTH_PER_SMS : 0 }}/{{ LENGTH_PER_SMS }} </span>
      </p>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormTextarea } from 'bootstrap-vue'

export default {
  components: {
    BForm,
    BModal,
    BFormTextarea,
  },

  data() {
    return {
      LENGTH_PER_SMS: 160,
      body: '',
    }
  },

  methods: {
    sendSMS() {
      this.$emit('send-sms', {
        body: this.body,
      })
    },

    resetData() {
      this.body = ''
    },
  },
}
</script>

<style></style>
